import React from 'react'
import PropTypes from 'prop-types'
import { Grid, IconButton, Typography, useTheme, useMediaQuery, Box, Paper } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'

import { CustomButton, CustomTable, ModalConfirmacao } from 'components'
import { useStyles } from './FormFenomenosCadavericos.styles'
import { useFormFenomenosCadavericos } from './hooks/useFormFenomenosCadavericos'
import { FormAddFenomenoCadaverico } from './FormAddFenomenoCadaverico'

export const FormFenomenosCadavericos = ({ idExameRealizado, idCadaver }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const {
    processandoFenomenos,
    fenomenosCadavericos,
    setFenomenosCadavericos,
    openAddFenomeno,
    setOpenAddFenomeno,
    openFichaDeletarFenomenoCadaverico,
    handleBotaoAdicionarFenomenoCadaverico,
    clickOpenModalDeletarFenomenoCadaverico,
    handleCloseModalDeletarFenomenoCadaverico,
    handleDeletarFenomenoCadaverico,
    setProcessandoFenomenos,
    dispatch,
  } = useFormFenomenosCadavericos({
    idExameRealizado,
    idCadaver,
  })

  const columns = [
    {
      title: 'Fenômeno',
      render: (rowData) => (
        <Typography className={classes.linhaTabela}>{rowData.tipo?.nome || '-'}</Typography>
      ),
    },
    {
      title: 'Observações',
      render: (rowData) => (
        <Typography className={classes.linhaTabela}>{rowData.observacoes || '-'}</Typography>
      ),
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <FormAddFenomenoCadaverico
        idExame={idExameRealizado}
        idCadaver={idCadaver}
        setFenomenosCadavericos={setFenomenosCadavericos}
        open={openAddFenomeno}
        setOpen={setOpenAddFenomeno}
        setProcessando={setProcessandoFenomenos}
        processando={processandoFenomenos}
        dispatch={dispatch}
      />

      <Grid className={classes.fieldGroup} alignItems="center" container justify="space-between">
        <Grid
          alignItems="flex-end"
          container
          justify="flex-end"
          spacing={3}
          className={classes.cabecalhoBotao}
        >
          <Grid item xs={12} sm="auto">
            <CustomButton
              color="primary"
              variant="contained"
              onClick={handleBotaoAdicionarFenomenoCadaverico}
            >
              <AddIcon className={classes.addIcon} />
              Adicionar Fenômeno cadavérico
            </CustomButton>
          </Grid>
        </Grid>
        <Grid
          className={classes.dados}
          alignItems="center"
          container
          justify="space-between"
          spacing={1}
        >
          <Grid item md={12} sm={12} xs={12} className={classes.tableContainer}>
            {isMobile ? (
              fenomenosCadavericos && fenomenosCadavericos.length > 0 ? (
                <Grid container spacing={2}>
                  {fenomenosCadavericos.map((item) => (
                    <Grid item xs={12} key={item.id}>
                      <Paper className={classes.fenomenoCard}>
                        <Box display="flex" justifyContent="space-between" alignItems="start" mb={1}>
                          <Typography
                            variant="subtitle2"
                            color="primary"
                            style={{ fontWeight: 'bold', fontSize: '14px' }}
                          >
                            {item.tipo?.nome || '-'}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => clickOpenModalDeletarFenomenoCadaverico(item)}
                            style={{ padding: 4 }}
                          >
                            <DeleteIcon color="error" fontSize="small" />
                          </IconButton>
                        </Box>
                        <Typography variant="body2" style={{ fontSize: '12px', color: '#666' }}>
                          <b>Observações:</b> {item.observacoes || '-'}
                        </Typography>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography
                  style={{
                    fontSize: '12px',
                    padding: '24px',
                    textAlign: 'center',
                    color: '#999',
                    fontStyle: 'italic',
                  }}
                >
                  Nenhum fenômeno registrado
                </Typography>
              )
            ) : (
              <CustomTable
                title=""
                columns={columns}
                data={fenomenosCadavericos}
                isLoading={processandoFenomenos}
                emptyDataSourceMessage="Nenhum fenômeno registrado"
                options={{
                  search: false,
                  pageSize: 6,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#f4f6f8',
                    fontSize: '12px',
                  },
                  toolbar: false,
                }}
                actions={[
                  {
                    icon: () => <DeleteIcon />,
                    tooltip: 'Deletar Item',
                    onClick: (event, rowData) => clickOpenModalDeletarFenomenoCadaverico(rowData),
                  },
                ]}
              />
            )}
          </Grid>
        </Grid>
      </Grid>

      <ModalConfirmacao
        aberto={openFichaDeletarFenomenoCadaverico}
        onClose={handleCloseModalDeletarFenomenoCadaverico}
        onConfirm={handleDeletarFenomenoCadaverico}
        titulo="Confirmar exclusão"
        confirmarColor="error"
        confirmarLabel="Confirmar Exclusão"
        processando={processandoFenomenos}
      >
        Tem certeza que deseja deletar este fenômeno cadavérico? Esta ação não pode ser desfeita.
      </ModalConfirmacao>
    </div>
  )
}

FormFenomenosCadavericos.propTypes = {
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idCadaver: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
